import styled from 'styled-components';

import {
  Card, Text, spacing, defaultBoxShadow
} from '@comicrelief/component-library';

const Section = styled.section.attrs({
  'data-test': 'meet-the-team'
})`
  text-align: center;
  background-color: ${({ theme, color }) => theme.color(color)};
`;

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${spacing('sm')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  @media ${({ theme }) => theme.breakpoints2026('S')} {
    flex-wrap: wrap;
    flex-direction: row;
    padding: 0;
  }
    
  @media ${({ theme }) => theme.breakpoints2026('M')} {
    padding: 0 ${spacing('md')};
  }
`;

const Title = styled(Text)`
  padding-top: ${spacing('xl')};
`;

const Item = styled(Card)`
  padding: 0 0 ${spacing('md')};
  margin: 0 0 ${spacing('md')};
  ${defaultBoxShadow()}

  @media ${({ theme }) => theme.breakpoints2026('S')} {
    width: calc(100% / 2 - ${spacing('l')} - 2 * ${spacing('l')});
    min-width: 200px;
    margin: 0 ${spacing('md')} ${spacing('md')};
  }

  @media ${({ theme }) => theme.breakpoints2026('L')} {
    width: calc(100% / 3 - ${spacing('md')} - 2 * ${spacing('md')});
  }
`;

const Container = styled.div`
  width: 100%;
`;

export {
  Section, Wrapper, Title, Item, Container
};
